import { render } from "./customerPage.vue?vue&type=template&id=23d8e502"
import script from "./customerPage.vue?vue&type=script&lang=js"
export * from "./customerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__